import { render, staticRenderFns } from "./SocialJobApply.vue?vue&type=template&id=ba922e1e"
import script from "./SocialJobApply.vue?vue&type=script&lang=js"
export * from "./SocialJobApply.vue?vue&type=script&lang=js"
import style0 from "./SocialJobApply.vue?vue&type=style&index=0&id=ba922e1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports